module.exports = __webpack_public_path__ + "img/signup-new-square-1.e9a42817.png";